import ErrorMessage from "legacy/ErrorMessage"
import CreditCardIconGroup from "legacy/credit-cards/CreditCardIconGroup"
import PropTypes from "prop-types"
import React from "react"

import { STRIPE_LOAD_ERROR_MESSAGE, getStripe } from "src/utils/stripe"

class StripeElement extends React.Component {
  constructor(args) {
    super(args)
    this.state = {}
  }

  componentDidMount() {
    this.setUpStripeOnce()
  }

  componentDidUpdate(prevProps) {
    if (this.props.disabled !== prevProps.disabled) {
      this.stripeAsyncSetup()
    }
  }

  componentWillUnmount() {
    this.unmounted = true
  }

  setUpStripeOnce() {
    if (!this.pendingSetup) {
      this.pendingSetup = this.stripeAsyncSetup().finally(() => {
        this.pendingSetup = null
      })
    }
  }

  async stripeAsyncSetup() {
    const stripe = await getStripe().catch(() => null)
    if (!stripe || this.unmounted) return

    this.stripe = stripe
    const elements = stripe.elements()
    this.card = elements.create("card", {
      disabled: this.props.disabled,
      style: {
        base: {
          lineHeight: "18px",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
        },
        invalid: {
          color: "#a94442",
          iconColor: "#a94442",
        },
      },
    })
    this.card.mount("#cardElement")
    this.setState({ cardErrors: null })
    this.card.addEventListener("change", ({ error }) => {
      if (error) {
        this.setState({ cardErrors: error.message })
      } else {
        this.setState({ cardErrors: null })
      }
    })
  }

  createStripePaymentMethod() {
    if (!this.stripe) {
      this.setUpStripeOnce()
      this.setState({ cardErrors: STRIPE_LOAD_ERROR_MESSAGE })
      this.props.errorCallback?.()
      return
    }

    this.setState({ cardErrors: null })
    this.stripe
      .createPaymentMethod({
        type: "card",
        card: this.card,
      })
      .then((result) => {
        if (result.error) {
          this.setState({ cardErrors: result.error.message })
          this.props.errorCallback?.()
        } else {
          this.props.successCallback(result.paymentMethod)
        }
      })
  }

  render() {
    return (
      <div>
        <div className="mb-3 lg:mb-1">
          <CreditCardIconGroup />
        </div>
        <div className="form-group">
          <label className="block">
            <div className="bs-mb-2">Card Details</div>
            <div className="form-control" id="cardElement" />
          </label>
          <ErrorMessage>{this.state.cardErrors}</ErrorMessage>
        </div>
      </div>
    )
  }
}

StripeElement.propTypes = {
  successCallback: PropTypes.func.isRequired,
  errorCallback: PropTypes.func,
  disabled: PropTypes.bool,
}

export default StripeElement
